import { featuredComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedComics() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              热门推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">大家都在看的漫画</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
          {featuredComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              tags={comic.tags}
              status={comic.status}
              updateInfo={comic.updateInfo}
              views={comic.views}
              rating={comic.rating}
              isNew={comic.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}